import { FC, useMemo } from "react";
import { FieldFormV2, FieldV2, LoadingV2, useFieldSchemaV2FactoryContext } from "@ucl/library";
import { FIELD_KEYS } from "@/constants";
import "./KeyPersonIdentificationDocumentsForm.scss";
import { FinancialApplicationFormSectionContextType, FinancialApplicationFormValidationDisplayBehavior } from "@/hooks/useFinancialApplicationFormSectionValidation";
import { createKeyPersonFormBuilder } from "../KeyPeople/KeyPersonFormBuilder";
import { EntityTypes } from "@/constants/entityTypes";
import { KeyPerson } from "@/types/KeyPerson";
import { useKeyPersonDocuments } from "@/hooks/useKeyPersonDocuments";
import { GovernmentIdType } from "@/types/enums";

export interface KeyPersonIdentificationDocumentsFormProps {
  keyPersonId: string;
  autoValidationBehavior?: FinancialApplicationFormValidationDisplayBehavior;
  availableFields?: string[];
  showHeader?: boolean;
  validationContextType: FinancialApplicationFormSectionContextType;
  governmentIdType?: GovernmentIdType;
}

export const KeyPersonIdentificationDocumentsForm: FC<KeyPersonIdentificationDocumentsFormProps> = (
  props
) => {
  const { formValue, setFormValue, saveIdentityDocuments } = useKeyPersonDocuments(
    props.keyPersonId
  );

  const { schemaFactory } = useFieldSchemaV2FactoryContext();

  const formBuilder = useMemo(() => {
    if (!schemaFactory) return undefined;
    return createKeyPersonFormBuilder(schemaFactory, props.validationContextType);
  }, [schemaFactory]);

  if (!schemaFactory || !formBuilder || !formValue) {
    return (
      <section className="key-person-identification-documents-form">
        <LoadingV2 />
      </section>
    );
  }

  return (
    <div className="key-person-identification-documents-form">
      <FieldFormV2<KeyPerson>
        value={formValue}
        fieldSchemaFormBuilder={formBuilder}
        onFormSubmit={async (value) => {
          await saveIdentityDocuments(value);
        }}
        onFieldChanged={(newValue, newFieldValue) => {
          setFormValue(newValue, newFieldValue);
        }}
        availableFields={props.availableFields}
      >
        <FieldV2
          fieldProps={FIELD_KEYS.KEY_PERSON.IDENTIFICATION_DOCUMENTS}
          complexFieldValue={{
            entityId: props.keyPersonId,
            entityType: EntityTypes.FinancialApplication.KeyPerson.EntityType,
            governmentIdType: props.governmentIdType,
            showHeader: props.showHeader,
          }}
        />
      </FieldFormV2>
    </div>
  );
};
